import type { ReactNode } from "react";

import {
  Divider,
  RoundedBox,
  Typography,
} from "@braintrust/braintrust-ui-components";

export type OfferPreviewSectionContainterProps = {
  children: ReactNode;
  title: ReactNode;
};

export const OfferPreviewSectionContainter = ({
  children,
  title,
}: OfferPreviewSectionContainterProps) => {
  return (
    <RoundedBox sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Typography component="span" variant="label" size="medium">
        {title}
      </Typography>
      <Divider color="beige" />
      {children}
    </RoundedBox>
  );
};
